<template>
  <div style="text-align: center;">
    <img src="../assets/images/no-data.png">
    <div style="margin-top: 10px; color: #909399">暂时没有{{ name }}策略
      <a slot="reference" class="text-blue" size="mini"
         style="border-bottom: 1px solid; text-decoration:none;cursor: pointer" type="text"
         @touchstart="add"
         @click="add">点击新建策略</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoData",
  props:['name'],
  methods:{
    add(){
      this.$emit("add");
    },
  }
}
</script>

<style scoped>
.text-blue:hover {
  color: #FFFFFF;
}
</style>
